import http from "../../utils/http"

/**
 * 获取新闻列表
 */
export function exhibitList(params) {
    return http({
        url: "/api/exhibit/page",
        data: params
    })
}

/**
 * 获取新闻分类列表
 */
export function exhibitClassList(params) {
    return http({
        url: "/api/exhibit/cat",
        data: params
    })
}

/**
 * 获取帮助详情
 */
export function exhibitDetail(params) {
    return http({
        url: "/api/exhibit/detail",
        data: params
    })
}

/**
 * 获取新闻列表
 */
export function exhibitCat(params) {
    return http({
        url: "/api/exhibit/cat",
        data: params
    })
}

